export default {
  'AF': 'Africa',
  'AN': 'Antartica',
  'AS': 'Asia',
  'EU': 'Europe',
  'NA': 'North America',
  'OC': 'Oceania',
  'SA': 'South America',
  'XX': 'Other'
}



// WEBPACK FOOTER //
// ./src/lang/continents/en.js